import { render, staticRenderFns } from "./CvTechPage.vue?vue&type=template&id=c42aa12e&"
import script from "./CvTechPage.vue?vue&type=script&lang=js&"
export * from "./CvTechPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports